import { useEffect, useState } from 'react';

export const useVisitCounter = (): number => {
    const [count, setCount] = useState(0);
    const pageKey = 'total_visits'; // Общий ключ для посещений сайта

    useEffect(() => {
        const incrementVisitCount = async () => {
            try {
                const response = await fetch(`${process.env.REACT_APP_API_CONFIG}page_visits/${pageKey}/`, {
                    method: 'PUT',
                    headers: {
                        'Accept': 'application/json', 
                    }
                });

                if (response.ok) {
                    const text = await response.text(); 
                    try {
                        const data = JSON.parse(text); 
                        setCount(data.visit_count);
                    } catch (error) {
                        console.error('Ошибка при разборе JSON:', error);
                        console.log('Полученный текст:', text);
                    }
                } else {
                    console.error('Ошибка при попытке увеличить счетчик посещений');
                }
            } catch (error) {
                console.error('Ошибка запроса:', error);
            }
        };

        incrementVisitCount();
    }, []); // Пустой массив зависимостей, чтобы эффект выполнился один раз при монтировании компонента

    return count;
};
